<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :actions="grid.actions"
          :exportFileName="title"
          @on-row-action-click="gridRowClick"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RegisteredDeviceService from "@/services/RegisteredDeviceService";
import Utils from "@/ecm/common/Utils";

export default {
  data() {
    return {
      title: this.$t("RegisteredDevices"),
      grid: {
        key: "registeredDevicesGrid",
        dataSource: RegisteredDeviceService.getGrid(),
        columns: [
          {
            field: "DeviceID",
            caption: this.$t("DeviceID"),
            type: "string",
          },
          {
            field: "DeviceName",
            caption: this.$t("Description"),
            type: "string",
          },
          {
            field: "UserDisplayName",
            caption: this.$t("User"),
            type: "string",
          },
          {
            field: "RegistrationDate",
            caption: this.$t("Date"),
            type: "string",
          },
        ],
        actions: [
          {
            name: "delete",
            icon: "mdi-delete",
            tooltip: this.$t("Delete"),
            color: "red",
          },
        ],
      },
    };
  },
  computed: {
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    gridRowClick(action) {
      if (action.name === "delete") {
        this.delete(action.data);
      }
    },
    delete(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          RegisteredDeviceService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(this.$t("Device") + " " + this.$t("DeletedSuccessfully"));
            }
          });
        }
      });
    },
  },
};
</script>
